import React, { useRef, useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Grid, Box } from '@mui/material'
import { MuiSelectAutoComplete, MuiButton } from '../../../../../components'
import keywordManagement from '../../../../../services/keywordManagement.service'
import { useGlobalStore } from '../../../../../store'
import { consoleLog, getObjectAsArray } from '../../../../../util'
import { OuterWrapper, Error, Message } from './style'

const Add = ({ onChange }) => {
  const { company } = useGlobalStore()
  const strAll = 'All'
  const initialFormObj = {
    keywordSelect: strAll,
    notesSelect: strAll,
    typeSelect: strAll
  }

  const form = useRef()
  // const [formSectionData, setFormSectionData] = useState(defaultDataFunc())
  const [formData, setFormData] = useState(initialFormObj)
  const [formError, setFormError] = useState('')
  const [formSuccess, setFormSuccess] = useState('')
  const [formSelectData, setFormSelectData] = useState({
    keyword: [],
    notes: [],
    type: [],
    subType: []
  })

  const onChangeHandler = (key, value) => {
    const obj = {
      ...formData,
      [key]: value || null
    }
    if (key === 'keywordSelect') {
      obj.keywordInput = null
    } else if (key === 'notesSelect') {
      obj.notesInput = null
    } else if (key === 'typeSelect') {
      obj.typeInput = null
    }
    setFormData(obj)
  }

  const submitPayload = async (e) => {
    e.preventDefault()

    const payload = { organizationId: company?.OrganizationId, keywordValue: formData.keywordSelect, keywordNotesValue: formData.notesSelect, keywordTypeValue: formData.typeSelect }
    const response = await keywordManagement.getOrganizationAggregationKeywordDetailsCountApi(payload)

    onChange(getObjectAsArray(response, 'adv'))
    setFormSuccess('Done')
  }

  const onload = async () => {
    try {
      const payload = { organizationId: company?.OrganizationId }
      const keywordApi = await keywordManagement.getOrganizationAggregationKeywordsApi(payload)

      const keywordArray = getObjectAsArray(keywordApi, 'adv').map(d => ({ label: d.KeywordValue, value: d.KeywordValue, valKeywordValue: d.KeywordValue, valKeywordId: d.KeywordId, valKeywordSearchTerm: d.KeywordSearchTerm }))
      keywordArray.push({ label: ' ', value: ' ', valKeywordValue: ' ', valKeywordId: ' ', valKeywordSearchTerm: ' ' })
      keywordArray.unshift({ label: strAll, value: strAll, valKeywordValue: strAll, valKeywordId: strAll, valKeywordSearchTerm: strAll })

      const notesApi = await keywordManagement.getOrganizationAggregationKeywordNotesApi(payload)
      const notesArray = getObjectAsArray(notesApi, 'adv').reduce((oldVal, newVal) => ([...oldVal, { label: newVal, value: newVal }]), [])
      notesArray.push({ label: ' ', value: ' ', valKeywordValue: ' ', valKeywordId: ' ', valKeywordSearchTerm: ' ' })
      notesArray.unshift({ label: strAll, value: strAll, valKeywordValue: strAll, valKeywordId: strAll, valKeywordSearchTerm: strAll })

      const typeApi = await keywordManagement.getOrganizationAggregationKeywordTypesApi(payload)
      const typeArray = getObjectAsArray(typeApi, 'adv').reduce((oldVal, newVal) => ([...oldVal, { label: newVal, value: newVal }]), [])
      typeArray.push({ label: ' ', value: ' ', valKeywordValue: ' ', valKeywordId: ' ', valKeywordSearchTerm: ' ' })
      typeArray.unshift({ label: strAll, value: strAll, valKeywordValue: strAll, valKeywordId: strAll, valKeywordSearchTerm: strAll })

      const payloadData = { organizationId: company?.OrganizationId, keywordValue: 'All', keywordNotesValue: 'All', keywordTypeValue: 'All' }
      const response = await keywordManagement.getOrganizationAggregationKeywordDetailsCountApi(payloadData)
      const response1 = getObjectAsArray(response, 'adv')
      if (response1.length === 0) onChange([])
      else if (response1.length === 1 && response1[0] === 'undefined') onChange([])
      else onChange([response1])

      setFormSelectData(prev => ({ ...prev, keyword: keywordArray, notes: notesArray, type: typeArray }))
      setFormError('')
      setFormSuccess('')
      setFormData(initialFormObj)
    } catch (error) {
      consoleLog('error = ', error)
    }
  }

  useEffect(() => {
    if (company?.OrganizationId) onload()
  }, [company?.OrganizationId])

  return (
    <OuterWrapper>
      <form ref={form} onSubmit={submitPayload} autoComplete='on'>
        <Grid container spacing={2}>
          <Grid item xs={4}>
            <MuiSelectAutoComplete
              data={formSelectData.keyword}
              name='keyword'
              placeholder='Keyword'
              label='Keyword'
              onChange={(e) => onChangeHandler('keywordSelect', e.target.value)}
              variant='standard'
              value={formData.keywordSelect}
            />
          </Grid>
          <Grid item xs={4}>
            <MuiSelectAutoComplete
              data={formSelectData.notes}
              name='notes'
              placeholder='Notes'
              label='Notes'
              onChange={(e) => onChangeHandler('notesSelect', e.target.value)}
              variant='standard'
              value={formData.notesSelect || ''}
            />
          </Grid>
          <Grid item xs={4}>
            <MuiSelectAutoComplete
              data={formSelectData.type}
              name='type'
              placeholder='Type'
              label='Type'
              onChange={(e) => onChangeHandler('typeSelect', e.target.value)}
              variant='standard'
              value={formData.typeSelect || ''}
            />
          </Grid>
          <Grid item xs={12}></Grid>
          <Grid item xs={13} style={{ justifyContent: 'space-between', display: 'flex' }}>
            <Box>
              {formError && <Error>{formError}</Error>}
              {formSuccess && <Message>{formSuccess}</Message>}
            </Box>
            <Box>
              <MuiButton
                onClick={submitPayload}
                type='submit'
                color='primary'
                variant='contained'
                style={{ width: '120px', marginRight: '10px' }}
              >
                Filter
              </MuiButton>
              <MuiButton
                onClick={() => onload()}
                type='button'
                color='primary'
                variant='contained'
                style={{ width: '120px' }}
              >
                Refresh
              </MuiButton>
            </Box>
          </Grid>
        </Grid>
      </form>
    </OuterWrapper>
  )
}

Add.propTypes = {
  onChange: PropTypes.func
}

export default Add
